export const getResiduoDestinacoes = (state) => state.residuoDestinacoes.lista
export const getIsCarregandoListaResiduoDestinacoes =
  (state) => state.residuoDestinacoes.isCarregandoLista
